<template>
    <div class="simple-bottom-popup-wrapper">

        <p>{{ popupTitle }}
            <template v-if="settings['privacy-policy'] || settings['cookie-policy']">
                {{ translations['gdpr.learn_more'] }}
            </template>
            <template v-if="settings['cookie-policy']">
                <a :href="settings['cookie-policy']" target="_blank">Cookie Policy</a>
            </template>
            <template v-if="settings['privacy-policy'] && settings['cookie-policy']">
                &
            </template>
            <template v-if="settings['privacy-policy']">
                <a :href="settings['privacy-policy']" target="_blank">Privacy Policy</a>
            </template>
        </p>
        <div @click="acceptCookie('simple')" class="popup-agree-btn">
            <p>{{ translations['gdpr.allow'] }}</p>
        </div>
    </div>
</template>

<script>
import CookieMixin from '../../mixins/CookieMixin.js';
import {mapState} from 'vuex';

export default {
	mixins: [CookieMixin],
	name: 'simple-bottom'
};
</script>

<style lang="scss">
    .simple-bottom-popup-wrapper {
        text-align: center;
        position: fixed;
        bottom: 0;
        box-shadow: 0 -5px 5px -5px #c7c7c7;
        padding: 10px;
        z-index: 9997;
        width: 100%;
        background: linear-gradient(to bottom, #ffffff 0%,#f1f1f1 100%);

        p {
            font-size: 14px;
            display: inline-block;
            color: #9e9e9e;
            margin: 0;

            @media(max-width: 767px) {
                display: block;
            }

            @media(max-width: 550px) {
                font-size: 12px;
            }
        }

        .popup-agree-btn {
            background: #ffc109;
            display: inline-block;
            margin-left: 25px;
            text-align: center;
            border-radius: 3px !important;
            padding: 10px;
            padding-left: 35px;
            padding-right: 35px;
            transition: all 0.3s;
            font-weight: 600;
            font-size: 14px;

            p {
                font-weight: 600;
                color: #464646;
                margin: 0;
            }

            &:hover {
                cursor: pointer;
                opacity: 0.8;
            }

            @media(max-width: 767px) {
                margin: 0;
                margin-top: 10px;
                padding: 8px;
                padding-left: 30px;
                padding-right: 30px;
            }

            @media(max-width: 550px) {
                font-size: 12px;
            }
        }

        a {
            text-decoration: underline;
            font-weight: 600;
            color: #a5a5a5;

            &:hover {
                cursor: pointer;
                opacity: 0.8;
            }
        }
    }
</style>